// Generated by BUCKLESCRIPT VERSION 4.0.14, PLEASE EDIT WITH CARE
'use strict';

function MakeBasic(M) {
  var apply = M[
  /* apply */
  0];
  var pure = M[
  /* pure */
  1];
  var $less$star$great = M[
  /* apply */
  0];
  return (
    /* module */
    [
    /* apply */
    apply,
    /* pure */
    pure,
    /* <*> */
    $less$star$great]
  );
}

exports.MakeBasic = MakeBasic;
/* No side effect */